import { __awaiter } from "tslib";
import log from 'pathfinder/utils/log';
export function fetchArticleStatsData(articleId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const url = new URL(`/rest.php/silver-surfer/article/${articleId}/top-contributions`, window.location.origin);
            const result = yield fetch(url.toString());
            if (result.ok) {
                return (yield result.json());
            }
            else {
                log.debug('Cant fetch article stats', result.text);
            }
        }
        catch (err) {
            log.error('Cant fetch article stats', err);
        }
        return null;
    });
}
